import * as React from 'react'
import { IconButton } from 'primitives/buttons/icon-button'
import * as Dialog from 'primitives/dialog'
import { tw } from 'utils/classnames'
import { CloseIcon } from 'primitives/icons/close'
import { Z_INDEX_MODALS } from 'constants/modals'

export interface ModalProps extends React.PropsWithChildren {
  className?: string
  isOpen: boolean
  onClose: () => void
}

export function Modal({ isOpen, onClose, className, children }: ModalProps) {
  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={open => {
        if (!open) {
          onClose()
          document.body.style.overflow = 'auto'
        }
      }}
    >
      <Dialog.Portal>
        <Dialog.Body zIndex={Z_INDEX_MODALS.default} className="backdrop-blur-sm">
          <div
            className={tw(
              'font-poppins bg-cf-white relative mx-2 flex w-full max-w-[450px] flex-col items-center rounded-[24px] text-[#2A1F3F] min-[1175px]:mx-24',
              className,
            )}
          >
            {children}
            <div
              className={tw(
                'absolute right-0 top-0',
                'min-[1175px]:-right-4 min-[1175px]:translate-x-full',
              )}
            >
              <Dialog.Close asChild>
                <IconButton
                  className={tw(
                    'text-cf-dreamy-cloud-800 group size-14 rounded-full bg-transparent active:bg-transparent',
                    'min-[1175px]:text-cf-white min-[1175px]:active:text-cf-white min-[1175px]:bg-cf-black/15 min-[1175px]:hover:bg-cf-black/30 min-[1175px]:active:bg-cf-black/30',
                  )}
                >
                  <CloseIcon className="transition-transform group-hover:scale-110" />
                </IconButton>
              </Dialog.Close>
            </div>
          </div>
        </Dialog.Body>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

export function Title({ children }: React.PropsWithChildren) {
  return <Dialog.DialogTitle asChild>{children}</Dialog.DialogTitle>
}

export function Content({
  children,
  className,
  containerClassName,
}: React.PropsWithChildren<{ className?: string; containerClassName?: string }>) {
  return (
    <div className={tw('w-full p-6 min-[1175px]:p-8', className)}>
      <div
        className={tw(
          'scroller-menu-y relative h-full max-h-[80dvh] overflow-y-auto',
          containerClassName,
        )}
        data-id="modal-scroller"
      >
        {children}
      </div>
    </div>
  )
}
